(() => {
  'use strict';
  if (window.__printoraCompactSizeLabelsV2) return;
  window.__printoraCompactSizeLabelsV2 = true;

  /* Shorten long size labels in the boxes; keep full value on the input/aria. */

  function compactLabel(raw) {
    const value = String(raw || '').replace(/\s+/g, ' ').trim();
    if (!value) return '';

    let match = value.match(/^(?:kids|youth|junior|children)\s+(\d+)\s*[–—-]\s*(\d+)\s*(?:years?|yrs?)?$/i);
    if (match) return `${match[1]}-${match[2]} yrs`;

    match = value.match(/^(\d+)\s*[–—-]\s*(\d+)\s*(?:years?|yrs?)$/i);
    if (match) return `${match[1]}-${match[2]} yrs`;

    match = value.match(/^(?:kids|youth|junior|children)\s+(\d+)\s*(?:years?|yrs?)$/i);
    if (match) return `${match[1]} yrs`;

    match = value.match(/^(?:adults?)\s+(.+)$/i);
    if (match) return match[1].trim();

    match = value.match(/^(\d+)\s*[–—-]\s*(\d+)\s*(?:months?|mths?|mnths?)\b/i);
    if (match) return `${match[1]}-${match[2]}`;

    match = value.match(/^(newborn)\b/i);
    if (match) return 'NB';

    return value;
  }

  function isSizeField(fieldset) {
    const legend = fieldset.querySelector('legend, .form__label');
    const text = String(legend?.childNodes?.[0]?.textContent || legend?.textContent || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    return /^size\b/.test(text) || fieldset.classList.contains('pv2-size-fieldset');
  }

  function syncField(fieldset) {
    if (!fieldset || !isSizeField(fieldset)) return;

    const radios = [...fieldset.querySelectorAll('input[type="radio"]')];
    radios.forEach((input) => {
      const full = String(input.value || '').trim();
      const short = compactLabel(full);
      if (!short || short === full) return;

      const label = input.id
        ? fieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`)
        : (input.nextElementSibling?.tagName === 'LABEL' ? input.nextElementSibling : input.closest('label'));
      if (!label) return;

      label.dataset.pv2FullSize = full;
      label.setAttribute('aria-label', full);
      label.classList.add('pv2-size-choice', 'pv2-compact-size');

      let text = label.querySelector('.text, .pv2-size-choice-text');
      if (!text) {
        text = document.createElement('span');
        text.className = 'text pv2-size-choice-text';
        const radio = label.querySelector('input[type="radio"]');
        if (radio && label.contains(radio)) {
          [...label.childNodes].forEach((node) => {
            if (node !== radio) node.remove();
          });
          label.appendChild(text);
        } else {
          label.textContent = '';
          label.appendChild(text);
        }
      }
      if (text.textContent !== short) text.textContent = short;
    });

    const header = fieldset.querySelector('[data-header-option]');
    const checked = fieldset.querySelector('input[type="radio"]:checked');
    if (header && checked) {
      const full = String(checked.value || '').trim();
      const short = compactLabel(full) || full;
      if (short && header.textContent !== short) header.textContent = short;
    }
  }

  function boot() {
    document.querySelectorAll('.productView fieldset, form[action*="/cart/add"] fieldset, .product-form__input').forEach(syncField);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('change', (event) => {
    const field = event.target?.closest?.('fieldset, .product-form__input');
    if (field) syncField(field);
  });
  new MutationObserver(() => boot()).observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(boot, 400);
  setTimeout(boot, 1200);
})();
